import { storeSet } from '@cmd/ui-utilities';
const { reducer: sidePanelViewReducer, selector: sidePanelViewSelector, updateAction: updateSidePanelView, } = storeSet('sidePanelView', null);
export { sidePanelViewReducer, updateSidePanelView, sidePanelViewSelector };
